import shadows from '@mui/material/styles/shadows';
import React, { useEffect, useState } from 'react'
import { GetUserModel } from '../../../ApiServices/Profile/ProfileApi';
import { daily_nakshatra_prediction } from '../../../ApiServices/Horoscope/BirthDetailsApi';
import dayjs from 'dayjs';
import HoroscopeBannerImg from "../../../assets/images/new/HoroscopeBanner.png";
import Breadcrumbs from '../../Breadcrumb';
import astrology from "../../../assets/images/new/astrology.png";
import panchang from "../../../assets/images/new/panchang.png";
import numerology from "../../../assets/images/new/numerology.png";
import zodiacSign from "../../../assets/images/new/zodiacSign.png";
import Astro from "../../../assets/images/new/services1 (1).jpg";
import Panchang from "../../../assets/images/new/services1 (2).jpg";
import NumerologyImage from "../../../assets/images/new/services1 (3).jpg";
import Prediction from "../../../assets/images/new/services1 (3).jpg";
import { useLocation, useNavigate } from 'react-router-dom';
const DailyPrediction = () => {
    const [animate, setAnimate] = useState(false);
    const navigate = useNavigate()
    const location = useLocation()
    const [dailyPredictionList, setDailyPredictionObj] = useState([])
    const categories = [
        {
            title: "Astrology",
            image: Astro,
            icon: astrology,
            text: "Book Astrology for your spiritual rituals and ceremonies.",
            color: "#ffa415",
            route: "/basic-details",
        },
        {
            title: "Panchang",
            image: Panchang,
            icon: panchang,
            text: "Get a Panchang for your up and down ",
            color: "#fc5528",
            route: "/daily-panchang",
        },
        {
            title: "Numerology",
            image: NumerologyImage,
            icon: numerology,
            text: "Numerology for better life",
            color: "#8139e7",
            route: "/numerology",
        },
        {
            title: "Zodiac Signs",
            image: Prediction,
            icon: zodiacSign,
            text: "Know about Prediction",
            color: "#399be7",
            route: "/Prediction ",
        }

    ];
    const cardDetails = [
        { key: 'Health', label: 'health' },
        { key: 'Emotions', label: 'Emotions' },
        { key: 'Profession', label: 'Profession' },
        { key: 'Luck', label: 'Luck' },
        { key: 'PersonalLife', label: 'Personal Life' },
        { key: 'Travel', label: 'Travel' },
    ]
    const pastelGradients = [
        "linear-gradient(135deg, #E0F8E0, #C1E1C1)", // Health - Soft Green
        "linear-gradient(135deg, #FDE2E4, #FAB1A0)", // Emotions - Soft Red/Pink
        "linear-gradient(135deg, #D6E6FF, #A6C8FF)", // Profession - Soft Blue
        "linear-gradient(135deg, #FFF5D1, #FFEB99)", // Luck - Soft Yellow
        "linear-gradient(135deg, #EAEAEA, #D6D6D6)", // Personal Life - Soft Grey
        "linear-gradient(135deg, #D1F2F2, #A0E7E5)" // Travel - Soft Cyan
    ];

    useEffect(() => {
        GetUserModelData()
        setTimeout(() => {
            setAnimate(true);
        }, 300); // Delay animation to make it smoother
    }, []);

    const GetUserModelData = async () => {
        // setLoader(true);

        const userID = JSON.parse(localStorage.getItem("userID"));
        try {
            const response = await GetUserModel(userID);
            if (response?.ResponseCode == 0) {
                // setLoader(false);
                const ModelData = response.DATA || []; // Assuming the data is an array and we need the first item

                const dob = new Date(ModelData[0]?.DOB);

                const year = dob.getFullYear();
                const month = dob.getMonth() + 1; // Months are zero-based (0 = January)
                const day = dob.getDate();

                const [hours, minutes] = ModelData[0]?.BIRTH_TIME.split(":");
                const apiParam = {
                    "day": day,
                    "month": month,
                    "year": year,
                    "hour": hours,
                    "min": minutes,
                    "lat": 25.7464,
                    "lon": 25.7464,
                    "tzone": 5.5
                }
                await GetDailyPredictionData(apiParam, dayjs(ModelData[0]?.DOB).format('DD/MM/YYYY'))

            } else {
                // setLoader(false);

                console.error('Error fetching data: ', response?.data?.data?.statusCode);
            }
        } catch (error) {
            // setLoader(false);

            console.error('Error', error);
        }
    };
    const GetDailyPredictionData = async (apiParam, birthDate) => {
        try {
            const response = await daily_nakshatra_prediction(apiParam);
            if (response !== null && response !== undefined) {
                // setLoader(false);
                setDailyPredictionObj((prev) => ({
                    ...prev,
                    Health: response?.prediction?.health,
                    Emotion: response?.prediction?.emotions,
                    Profession: response?.prediction?.profession,
                    Luck: response?.prediction?.luck,
                    Personal_life: response?.prediction?.personal_life,
                    Travel: response?.prediction?.travel,

                }));

            } else {
                // setLoader(false);

                console.error('Error fetching data: ', response);
            }
        } catch (error) {
            // setLoader(false);

            console.error('Error', error);
        }
    };

    return (
        <>
            <section className="page-header">
                <div
                    className="page-header__bg"
                    style={{ backgroundImage: `url(${HoroscopeBannerImg})` }}
                ></div>
                <div className="container" style={{ display: 'block' }}>
                    <h2 className="page-header__title bw-split-in-left">Astro Details</h2>
                    <div >
                        <Breadcrumbs />
                    </div>
                </div>
            </section>
            <div className="container pt-4">
                <div className="row justify-content-center text-center g-4">
                    {categories.map((category, index) => (
                        <div key={index} className="col-6 col-sm-4 col-md-2" style={{ cursor: 'pointer' }}
                            onClick={() => navigate(`${category?.route}`)}
                        >
                            <div

                                className="rounded-circle bg-white shadow d-flex align-items-center justify-content-center mx-auto"
                                style={{ width: "70px", height: "70px", transition: "0.3s", cursor: 'pointer' }}
                            >
                                <img
                                    src={category.icon}
                                    alt={category.title}
                                    style={{ maxWidth: "50px", maxHeight: "50px", objectFit: "contain" }}
                                />
                            </div>
                            <p
                                className="mt-2 fw-semibold d-flex justify-content-center"
                                style={{
                                    color: category?.route === location?.pathname ? "#a52444" : "#212529", // fallback to Bootstrap's default
                                }}
                            >
                                {category.title}
                            </p>

                        </div>
                    ))}
                </div>
            </div>

            {/* <h3 className='text-center m-3'>Daily Prediction</h3> */}
            <div className='container'>
                <div className="row">
                    {Object?.entries(dailyPredictionList || {}).map(([key, value], index) => (
                        <div key={index} className="col-md-4 col-sm-6 col-12 mb-4 ">
                            <div
                                className={`card text-center shadow-md ${animate ? 'slide-in-left' : 'hidden'} `}
                                style={{
                                    height: '13em',
                                    background: pastelGradients[index % pastelGradients.length], // Cycles through gradients
                                    color: "#333", // Darker text for contrast
                                    textDecoration: "none",
                                    border: "none", // Remove default border
                                    borderRadius: "12px", // Softer corners

                                }}
                            >
                                <div className="card-body">
                                    <h5 className="card-title mt-3">{key}</h5>
                                    <p className='p-1' style={{ textAlign: 'justify' }}>{value}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}

export default DailyPrediction
